//config.js
export const SET_SHARD = 'SET_SHARD';
export const SET_WINDOW = 'SET_WINDOW';

//feedback.js
export const OPEN_FEEDBACK = 'OPEN_FEEDBACK';
export const CLOSE_FEEDBACK = 'CLOSE_FEEDBACK';
export const SET_FEEDBACK_LOCATION = 'SET_FEEDBACK_LOCATION';
export const SET_FEEDBACK_SHARD = 'SET_FEEDBACK_SHARD';
export const CLEAR_FEEDBACK_LOCATION = 'CLEAR_FEEDBACK_LOCATION';
export const SET_FEEDBACK_ISP = 'SET_FEEDBACK_ISP';
export const SET_FEEDBACK_ISP_OTHER = 'SET_FEEDBACK_ISP_OTHER';
export const SET_FEEDBACK_SUBMITTING = 'SET_FEEDBACK_SUBMITTING';
export const SET_FEEDBACK_DATA = 'SET_FEEDBACK_DATA';
export const SET_FEEDBACK_STEP = 'SET_FEEDBACK_STEP';

//location.js
export const LOCATION_LOADING = 'LOCATION_LOADING';
export const RECEIVE_LOCATION = 'RECEIVE_LOCATION';
export const LOCATION_LOADING_ERROR = 'LOCATION_LOADING_ERROR';

//player.js
export const SET_PLAYER_LOADED = 'SET_PLAYER_LOADED';
export const SET_PLAYER_LOADING = 'SET_PLAYER_LOADING';
export const SET_PLAYER_LOADING_ERROR = 'SET_PLAYER_LOADING_ERROR';
export const SET_PLAYER_NOT_FOUND = 'SET_PLAYER_NOT_FOUND';
export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const RECEIVE_PLAYER = 'RECEIVE_PLAYER';
export const RECEIVE_PLAYER_LOCATION = 'RECEIVE_PLAYER_LOCATION';
export const SWITCH_PLAYER_LOCATION = 'SWITCH_PLAYER_LOCATION';
export const OPEN_ASSESSMENT = 'OPEN_ASSESSMENT';
export const CLOSE_ASSESSMENT = 'CLOSE_ASSESSMENT';

//search.js
export const OPEN_SEARCH = 'OPEN_SEARCH';
export const CLOSE_SEARCH = 'CLOSE_SEARCH';
export const SET_SEARCH_STEP = 'SET_SEARCH_STEP';

//shard.js
export const SHARDS_LOADING = 'SHARDS_LOADING';
export const RECEIVE_SHARDS = 'RECEIVE_SHARDS';

//timeseries.js
export const RECEIVE_TIMESERIES = 'RECEIVE_TIMESERIES';
export const SET_TIMESERIES_LOADING = 'SET_TIMESERIES_LOADING';
export const TIMESERIES_LOADING_ERROR = 'TIMESERIES_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/actions/types.js